
    import { checkLoafSupport } from '/main.js';

    const slowButton = document.getElementById('slowButton');
    const clearBtn = document.getElementById('clearBtn');
    const supportInfo = document.getElementById('supportInfo');

    // Verificar soporte (sin duplicar mensaje)
    const isSupported = checkLoafSupport();

    console.log('%c═════════════════════════════════════════', 'color: #1a73e8; font-weight: bold');
    console.log('%cEjemplo 03: PerformanceObserver básico', 'color: #1a73e8; font-weight: bold; font-size: 14px');
    console.log('%c═════════════════════════════════════════', 'color: #1a73e8; font-weight: bold');
    console.log('');

    // Solo mostrar info en el elemento específico, el warning global ya se muestra por checkLoafSupport()
    if (isSupported) {
      console.log('✅ LoAF API disponible');
      supportInfo.innerHTML = '<strong>✅ Tu navegador soporta Long Animation Frames API</strong>';
    } else {
      console.warn('❌ LoAF API no disponible en este navegador');
      supportInfo.innerHTML = '<strong>💡 Consulta el mensaje de compatibilidad arriba</strong>';
    }

    console.log('Entry types soportados:', PerformanceObserver.supportedEntryTypes);
    console.log('');
    console.log('👀 Observando long-animation-frames...');
    console.log('💡 Haz clic en el botón para generar un frame lento');
    console.log('');

    // ============================================
    // CONFIGURACIÓN BÁSICA DEL OBSERVER
    // ============================================
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // Simplemente hacer log del entry completo
        console.log('🔍 Frame lento detectado:', entry);
        console.log('   └─ Duration:', entry.duration + 'ms');
        console.log('   └─ Blocking duration:', entry.blockingDuration + 'ms');
        console.log('   └─ Scripts ejecutados:', entry.scripts.length);
        console.log('');
        console.log('💡 Expande el objeto anterior para ver todos los detalles');
        console.log('');
      }
    });

    // Observar long animation frames
    try {
      observer.observe({
        type: 'long-animation-frame',
        buffered: true  // Incluir frames anteriores
      });
    } catch (e) {
      console.error('❌ Error al configurar observer:', e.message);
    }

    // ============================================
    // BOTÓN PARA GENERAR FRAME LENTO
    // ============================================
    slowButton.addEventListener('click', function generateSlowFrame() {
      console.log('👆 Generando frame lento...');

      // Bloquear el main thread por ~200ms
      const start = performance.now();
      while (performance.now() - start < 200) {
        Math.random() * Math.random();
      }

      slowButton.textContent = 'Frame lento generado ✓';
      setTimeout(() => {
        slowButton.textContent = 'Generar frame lento';
      }, 1000);

      console.log('✅ Procesamiento completado. Esperando LoAF entry...');
      console.log('');
    });

    // ============================================
    // LIMPIAR CONSOLA
    // ============================================
    clearBtn.addEventListener('click', () => {
      console.clear();
      console.log('%c═════════════════════════════════════════', 'color: #1a73e8; font-weight: bold');
      console.log('%cEjemplo 03: PerformanceObserver básico', 'color: #1a73e8; font-weight: bold; font-size: 14px');
      console.log('%c═════════════════════════════════════════', 'color: #1a73e8; font-weight: bold');
      console.log('');
      console.log('👀 Observando long-animation-frames...');
      console.log('💡 Haz clic en el botón para generar un frame lento');
      console.log('');
    });
  